export default __webpack_public_path__ + "static/JA1-fb4f29db4d733bd294283b0f5eef47f9.png";